import { useEffect, useRef, useState } from 'react';
import { getSearchResultsMessage } from '../utils/searchResultsAnnouncement';

export const useSearchResultsAnnouncement = (
  resultCount: number,
  isLoading: boolean,
  searchQuery: string
): string => {
  const [message, setMessage] = useState('');
  const wasLoading = useRef(false);
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      wasLoading.current = isLoading;
      return;
    }

    if (isLoading) {
      wasLoading.current = true;
      return;
    }
    if (!wasLoading.current) {
      return;
    }
    wasLoading.current = false;

    if (!(searchQuery || '').trim()) {
      return;
    }

    const nextMessage = getSearchResultsMessage(resultCount);
    setMessage('');
    const timeoutId = window.setTimeout(() => {
      setMessage(nextMessage);
    }, 50);

    return () => window.clearTimeout(timeoutId);
  }, [resultCount, isLoading, searchQuery]);

  return message;
};
